import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './en';

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

// Keep <html dir> in sync with the language so RTL languages (e.g. Arabic) lay out correctly later.
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = i18n.dir(lng);
});

export default i18n;
